import * as React from 'react';
import { useSelector } from 'react-redux';

import { useAddress, useUnderground, useLocationId, usePreviewImage } from './hooks';
import { UserCardOffer } from '../../components/UserCardMobile/UserCardOffer';
import { offerSelector } from '../../selectors';

export const UserCardOfferContainer: React.FC = () => {
  const offer = useSelector(offerSelector);

  const address = useAddress(offer?.geo);
  const underground = useUnderground(offer?.geo);
  const locationId = useLocationId(offer?.geo);
  const previewImage = usePreviewImage(offer);

  if (!offer || !offer.geo || !address) {
    return null;
  }

  return (
    <UserCardOffer
      locationId={locationId}
      fullUrl={offer.fullUrl}
      formattedFullInfo={offer.formattedFullInfo}
      address={address}
      previewImage={previewImage}
      underground={underground}
    />
  );
};
